import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { loadLabels } from '../../action/job/load-labels';
import { jobLabelsSelector, jobSelector } from '../../reducers/job-selectors';

import { JobApplicantLabels } from '../../widgets/job-applicant-labels';

type InputProps = {
  jobId: number;
};

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  job: jobSelector(state, ownProps.jobId),
  labels: jobLabelsSelector(state, ownProps.jobId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadLabels: () => dispatch(loadLabels(ownProps.jobId)),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = InputProps & StateProps & DispatchProps;

class HighQualityCandidateSettingsViewComponent extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.actions.loadLabels();
  }

  render() {
    const { labels, job } = this.props;

    if (!labels) {
      return null;
    }

    const enabledLabels = labels
      .filter((label) => !label.isAutoManaged)
      .filter((label) =>
        job?.HqcSettings?.find((s) => s.automatedLabelKey === label.automatedLabelKey),
      );

    if (enabledLabels.length === 0) {
      return (
        <Grid item>
          <Typography variant="body1">This job has no filters on its applicants.</Typography>
        </Grid>
      );
    }

    return (
      <Grid item>
        <JobApplicantLabels labels={enabledLabels} />
      </Grid>
    );
  }
}

export const HighQualityCandidateSettingsView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HighQualityCandidateSettingsViewComponent);
